import React, { useEffect, useState } from 'react'
import '../assets/style.css'
import {Link, useNavigate,redirect } from 'react-router-dom'
import UseLogin from '../hooks/useLogin'

function Login() {
    const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
    const {data,getData,error,token}=UseLogin({email,password})
    const [isValid,setIsValid] = useState('')

    const loginHandler =()=>{

      if(email ==''){
        setIsValid('email is required')
       }
       if(password == ''){
         setIsValid('password is required')
       }
      if(isValid.length ==0){
         getData()
      console.log(error)
      }
     
    }

  useEffect(()=>{
    if(token && token.length >0){
      navigate("/home")
    }
    localStorage.setItem('authToken',token)
  },[token,navigate])
  return (
    <div className='container'>
        <div className='loginContainer'>
            <h3>Login</h3>
            {isValid && isValid.length > 0 && <div className="alert alert-danger" role="alert">{isValid}</div>}
            {token && token.length >0 && <div className="alert  alert-success" role="alert">{token}</div>}
            {error && error.length > 0 && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className='inputContainer'>
            <label htmlFor='email'>Email</label>
            <input type='email' placeholder='Email' id='email' onChange={(e) => setEmail(e.target.value)}/> 
            </div>
         
           <div className='inputContainer'>
            <label htmlFor='password'>Password</label>
            <input type='password' placeholder='password' id='password' onChange={(e)=> setPassword(e.target.value)}/> 
            </div>
         <button className='loginBtn' onClick={loginHandler}>Login</button>
          <Link to='/register'>Don't have an account</Link>
        </div>
 
    </div>
  )
}

export default Login
